export default {
  VOTE: 'actionVote',
  CAST_VOTE: 'castVote',
  VOTE_CASTED: 'voteCasted'
}
